module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bQLFe"))).then(() => parcelRequire('d0iPb'));